import {Component, EventEmitter, HostBinding, OnInit, Output, Input, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef, HostListener, AfterViewInit} from '@angular/core';
import {IsAuthorizedService} from '../services/is-authorized.service';
import {mainPath} from '../../app-routing.constants';
import {ContactApiService} from '../../../../projects/api/src/contact/contact-api.service';
import {
  DEFAULT_SCREEN_CHART,
  DEFAULT_SCREEN_EVENTSLOG,
  DEFAULT_SCREEN_HOME,
  DEFAULT_SCREEN_MAP
} from '../../login/login-form/default-screen.const';
import {ActivatedRoute} from '@angular/router';
import {UserInfo} from '../../../../projects/api/src/user/user.model';
import {UserStatusResolverService} from '../resolvers/user-status-resolver.service';
import {NotificationService} from '../../API/notification.service';
import {filter} from 'rxjs/operators';
import {matchActionStatus} from '../../../../projects/api/src/reactive-service.abstract';
import {MenuService} from '../../main-temp/menu/menu.service';
import _ from 'lodash';
import {ConfigureService} from '../../../../projects/common/modules/configure/configure.service';
import {UserService} from '../services/user.service';

const DESKTOP_WIDTH = 1200;

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  @HostBinding('class') classes = 'c-navbar c-navbar_default u-hidden-print';
  @Input() showSpinner = false;
  @Input() acceptMessage: any;
  @Output() spinnerToggle = new EventEmitter();
  @Output() menuToggle = new EventEmitter();
  @Output() notifyMessage = new EventEmitter();

  @ViewChild('menuToggle', {static: false}) menuToggleBtn: ElementRef;
  @HostListener('window:resize', ['$event'])
  onResize = _.throttle((event) => {
    this.checkSize();
  }, 100);
  public profile: UserInfo;

  public logoPath = ['/', mainPath, 'eventslog'];
  public logoTitle = 'Event Title';

  documentationUrl: string;
  public currentCompany;
  public isDesktop = false;
  private contactSubscription;
  private userSubscription;

  private hasCallPrivilege = false;
  private appCode = '';

  constructor(private isAuthorizedService: IsAuthorizedService,
              private route: ActivatedRoute,
              private userService: UserStatusResolverService,
              private userService2: UserService,
              private menuService: MenuService,
              private cdr: ChangeDetectorRef,
              private contactApi: ContactApiService,
              private notifyService: NotificationService,
              private config: ConfigureService) {
    const tmp = this.config.options.appName;
    this.appCode = tmp ? tmp : '';
  }

  public isAuthorized() {
    return this.isAuthorizedService.isAuthorized.getValue();
  }

  ngOnInit() {
    this.hasCallPrivilege = this.appCode === 'app' && this.userService2.checkAccess('asterisk_phone:read');
    this.userSubscription = this.userService.defaultScreen$.subscribe((defaultScreen) => {
      this.defaultScreenInit(defaultScreen);
    });
    this.defaultScreenInit();
    this.contactSubscription = this.contactApi.getContactInfo()
      .subscribe(data => {
        if (data && data.docUrl) {
          this.documentationUrl = data.docUrl.indexOf('http') >= 0 ? data.docUrl : 'https://' + data.docUrl;
        }
      });
    this.contactApi.events.pipe(filter(matchActionStatus('done', ['save']))).subscribe((data) => {
      if (data && data.result) {
        this.documentationUrl = data.result.docUrl;
      }
    });
  }

  ngAfterViewInit() {
    this.checkSize();
  }

  ngOnDestroy() {
    this.contactSubscription.unsubscribe();
    this.userSubscription.unsubscribe();
  }

  defaultScreenInit(defaultScreen?: number) {
    if (!defaultScreen) {
      const routeData = this.route.snapshot.data;
      if (routeData.loginInfo) {
        this.profile = routeData.loginInfo;
        this.currentCompany = this.profile.company; // routeData.currentCompany;
      }
    } else {
      this.profile.defaultScreen = defaultScreen;
    }

    if (this.config.options.appConfig.typeOfDefaultUrl === 'static') {
      this.logoPath = [this.config.options.appConfig.defaultUrl];
    }

    if (this.config.options.appConfig.typeOfDefaultUrl === 'dynamic') {
      switch (this.profile.defaultScreen) {
        case DEFAULT_SCREEN_EVENTSLOG:
          this.logoPath = ['/', mainPath, 'eventslog'];
          this.logoTitle = 'Event Log';
          break;
        case DEFAULT_SCREEN_CHART:
          this.logoPath = ['/', mainPath, 'charts'];
          this.logoTitle = 'charts';
          break;
        case DEFAULT_SCREEN_MAP:
          this.logoPath = ['/', mainPath, 'map'];
          this.logoTitle = 'map';
          break;
        case DEFAULT_SCREEN_HOME:
          this.logoPath = ['/app/home'];
          this.logoTitle = 'Home';
          break;
        default:
          this.logoPath = [`/main/dashboard/${this.profile.defaultScreen}`];
          this.logoTitle = 'Dashboard';
      }
    }

  }

  clickedOutsideOverlay(e) {
    if (!this.isDesktop && !(this.menuToggleBtn.nativeElement as HTMLElement).contains(e.target) && !(e.target.closest('.c-main-menu'))) {
      this.collapseMenu();
    }
  }

  public collapseMenu() {
    this.menuService.isCollapsed.next(true);
  }

  menuHandle() {
    this.menuToggle.emit();
    setTimeout(() => this.notifyService.event$.emit({action: 'menu_toggle'}), 0);
  }

  checkSize() {
    const isDesktop = window.innerWidth >= DESKTOP_WIDTH;
    if (this.isDesktop !== isDesktop) {
      this.isDesktop = isDesktop;
      this.cdr.detectChanges();
    }
  }

  gotNewMessage(event) {
    this.notifyMessage.emit(event);
  }
}
